import React from 'react'
import { Link } from 'react-router-dom'
import { useLocation } from 'react-router'
import get from 'lodash/get'

import { Accordion, Banner, Button, Page, StatusPill, Text, UppercaseLabel } from '@fielded/shared-ui'
import capitalize from '@fielded/shared-ui/src/utils/capitalize'
import { Home, Truck } from '@fielded/shared-ui/src/icons'
import { SHIPMENT_STATUS, SHIPMENT_STATUS_TO_LMD_DISPLAY_STATUS } from '@fielded/fs-api/lib/shipment/constants'

import { formatDate } from '../../../../../van-shared/utils/utils'
import ProductAccordionItem from '../../../../../van-shared/components/ProductAccordionItem'

const FacilityDeliveryDetail = ({
  otp,
  history,
  delivery,
  products,
  isPsmReseller,
  isDeliveryReceived,
  snapshotId,
  onConfirmDelivery
}) => {
  const location = useLocation()

  const prevPath = get(location, 'state.prevPath', '')
  const fromHomeRoute = prevPath === '/'

  const formattedDate = formatDate(delivery.date, 'long')
  const driverName = get(delivery, 'updatedBy.user', '') // TODO: get driver's name
  const showDriver = (driverName !== get(delivery, 'destination.sdp')) && (driverName !== get(delivery, 'createdBy.user'))
  const isDeliveryDelayed = delivery.status === SHIPMENT_STATUS.DELAYED

  const displayOTP = otp && !isDeliveryReceived

  let title = 'Deliveries'
  let icon = <Truck />
  if (fromHomeRoute) {
    title = 'Home'
    icon = <Home />
  }

  let tableHeader = 'The following products are scheduled for delivery'
  if (isDeliveryReceived) {
    tableHeader = 'The following products have been delivered'
  }

  return (
    <Page>
      <Page.HeaderNew
        title={title}
        icon={icon}
        history={history}
        subtitle='Delivery'
      />

      <Page.Panel narrow alignLeft>
        <Page.Panel.Section>
          <section className='facility-delivery-detail__header-info'>
            <StatusPill
              className={`delivery-location__status--${delivery.status}`}
              label='Status'
              value={capitalize(SHIPMENT_STATUS_TO_LMD_DISPLAY_STATUS[delivery.status])}
            />
            <StatusPill
              label='Date'
              value={formattedDate}
            />
            {showDriver && (
              <StatusPill
                label='Driver'
                value={driverName || 'TBD'}
              />
            )}
            <StatusPill
              label='ID'
              value={delivery.shipmentNo || 'TBD'}
            />
          </section>

          {isDeliveryReceived && (
            <Button
              className='vs-u-margin-top'
              component={Link}
              to={`/shipments/last-mile-deliveries/delivery-statement/${snapshotId}`}
              colorVariant='brand'
              fill='outline'
            >
              View delivery note
            </Button>
          )}
        </Page.Panel.Section>
      </Page.Panel>

      {isDeliveryDelayed && (
        <Page.Panel narrow alignLeft withMinimalMargin>
          <Banner
            title='Temporary delay in delivery'
            center={false}
            inline
          >
            We regret to inform you of delays in your order delivery. We appreciate your understanding during this time.
          </Banner>
        </Page.Panel>
      )}

      {displayOTP && (
        <Page.Panel narrow alignLeft withMinimalMargin>
          <section className='facility-delivery-detail__otp-info'>
            <Text>To receive this delivery, please provide the OTP directly to the driver in person.</Text>
            <Text
              className='facility-delivery-detail__otp'
              color='brand'
              bold
            >
              Your OTP is: {otp}
            </Text>
          </section>
        </Page.Panel>
      )}

      <Page.Panel narrow alignLeft withMinimalMargin={!displayOTP}>
        <section className='facility-delivery-detail__table'>
          <Text className='vs-u-margin-bottom-double'>{tableHeader}:</Text>

          <div className='facility-delivery-detail__table-header'>
            <UppercaseLabel>Products</UppercaseLabel>
            <UppercaseLabel>Qty</UppercaseLabel>
          </div>

          <Accordion>
            {products.map(product => (
              <ProductAccordionItem
                key={product._id}
                product={product}
              />
            ))}
          </Accordion>
        </section>
      </Page.Panel>

      {!isDeliveryReceived && isPsmReseller && (
        <Page.Footer fixed nowrap>
          <Button
            colorVariant='brand'
            fill='full'
            onClick={onConfirmDelivery}
          >
            Confirm delivery
          </Button>
        </Page.Footer>
      )}
    </Page>
  )
}

export default FacilityDeliveryDetail
